/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Speakers_Metrics_Export_Failed_ToastInputs */

const en_speakers_metrics_export_failed_toast = /** @type {(inputs: Speakers_Metrics_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
};

const fr_speakers_metrics_export_failed_toast = /** @type {(inputs: Speakers_Metrics_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
};

const de_speakers_metrics_export_failed_toast = /** @type {(inputs: Speakers_Metrics_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
};

const it_speakers_metrics_export_failed_toast = /** @type {(inputs: Speakers_Metrics_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
};

const ru_speakers_metrics_export_failed_toast = /** @type {(inputs: Speakers_Metrics_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
};

const es_speakers_metrics_export_failed_toast = /** @type {(inputs: Speakers_Metrics_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
};

const zh_cn2_speakers_metrics_export_failed_toast = /** @type {(inputs: Speakers_Metrics_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
};

const ja_speakers_metrics_export_failed_toast = /** @type {(inputs: Speakers_Metrics_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
};

const hi_speakers_metrics_export_failed_toast = /** @type {(inputs: Speakers_Metrics_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
};

const pt_pt2_speakers_metrics_export_failed_toast = /** @type {(inputs: Speakers_Metrics_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Speaker metrics export failed: {error}" |
*
* @param {Speakers_Metrics_Export_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_export_failed_toast = /** @type {((inputs: Speakers_Metrics_Export_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Export_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_metrics_export_failed_toast(inputs)
	if (locale === "de") return de_speakers_metrics_export_failed_toast(inputs)
	if (locale === "it") return it_speakers_metrics_export_failed_toast(inputs)
	if (locale === "ru") return ru_speakers_metrics_export_failed_toast(inputs)
	if (locale === "es") return es_speakers_metrics_export_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_metrics_export_failed_toast(inputs)
	if (locale === "ja") return ja_speakers_metrics_export_failed_toast(inputs)
	if (locale === "hi") return hi_speakers_metrics_export_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_metrics_export_failed_toast(inputs)
	return en_speakers_metrics_export_failed_toast(inputs)
});